(function () {
    'use strict';

    angular.module("imApp").factory("stockCorrectionsService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 2489,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
